<template>
	<v-card flat color="transparent" class="pa-2">	
		<NavigationItem 
			name="Einloggen"
			iconcolor="primary"
			description="Hier erhalten Sie Zugriff auf Ihren Arbeitsplatz"
			type="click"
			icon="mdi-login-variant"
			@click="dialog = true"
		></NavigationItem>				
		<v-dialog v-model="dialog" max-width="460">
			<v-card>
				<DialogTitle title="Log In" @close="dialog = false"></DialogTitle>
				<v-card-text>
					<v-text-field prepend-icon="mdi-at" label="Email Address" v-model="email"></v-text-field>
					<v-text-field prepend-icon="mdi-lock" type="password" label="Password" v-model="password"></v-text-field>
					<v-alert dense type="error" v-if="error" class="mr-4 ml-4">There was a problem logging you in. Consider resetting your password or <a href="/contact">contact us</a></v-alert>
					<small class="pa-0 ml-5"><a class="text--secondary" @click="forgotPassword">Forgot Password</a></small>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn rounded color="primary" text @click="loginWithPassword">
						Log In
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>   	
		<NavigationItem 
			name="Einloggen mit Google"
			iconcolor="primary"
			description="Hier bequem mit Google anmelden"
			type="click"
			icon="mdi-google"
			@click="loginWithGoogle"
		></NavigationItem>		
	</v-card>
</template>

<script type="text/javascript">
	import Vuex from "vuex";
	import DialogTitle from "@/components/elements/DialogTitle"
	import NavigationItem from "@/components/elements/NavigationItem"

	export default {
		name: "Login", 
		props: {
			color: { type: String, default: () => "primary2"}
		},
		data: () => {
			return {				
				dialog: null,
				password: null, 
				email: null, 
				error: null
			}
		},
		components: {
			DialogTitle,
			NavigationItem
		},
		computed:  {
			...Vuex.mapState({
				auth: state => state.auth,
			})
		},
		methods: {
			redirect(){
				if( this.$route.path == "/" && this.auth.logged_in  ){
					this.$router.push("assessment")
				}
			},
			forgotPassword(){
				this.dialog = false; 
				this.$emit('forgotPassword')
			},
			loginWithGoogle(){
				this.$store.dispatch("auth/loginWithGoogle").then( () => {
					this.redirect();
				}).catch( e => {
					e;
				})
			}, 
			loginWithPassword(){
				this.$store.dispatch("auth/loginWithPassword", {email: this.email, password: this.password}).then( () => {
					this.redirect();
				}).catch( () => {
					this.error = true;
				})
			}
		}
	}
</script>


